import React from 'react';
import m1 from "../../../assets/newCars/m1.jpeg"
import m2 from "../../../assets/newCars/m2.jpeg"
import m3 from "../../../assets/newCars/m3.jpeg"
import m4 from "../../../assets/newCars/m4.webp"
import b1 from "../../../assets/newCars/b1.jpg"
import b2 from "../../../assets/newCars/b2.jpeg"
import b3 from "../../../assets/newCars/b3.jpg"
import b4 from "../../../assets/newCars/b4.webp"
import b5 from "../../../assets/newCars/b5.webp"
import t1 from "../../../assets/newCars/t1.jpeg"
import t2 from "../../../assets/newCars/t2.jpg"
import t3 from "../../../assets/newCars/t3.jpeg"
import t4 from "../../../assets/newCars/t4.jpg"

const NewCars = () => {
    return (
        <div>
             <div className='mt-32'>
		<h1 className='text-center text-3xl font-bold mt-16'>Recently arrived cars</h1>
	</div>


            <div className='mt-10 mx-10'>
            <section className="py-6 bg-indigo-500 dark:dark:text-gray-50 rounded-lg">
	<div className="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4">

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={m4} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={t4} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={b5} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={b1} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={b2} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={t3} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>
        
          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={t1} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>
        
          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={b4} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={t2} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={b3} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={m1} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
           <img src={m2} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="img" /> 
          </div>

	</div>
</section>
        </div>
        </div>
    );
};

export default NewCars;